import React, { useContext, useState } from 'react'
import { IonRow, IonCol, IonLabel, IonInput, IonButton, IonItem, IonSelect, IonSelectOption, IonCard } from '@ionic/react'
import db from '../../resources/db';
import { toastController } from '@ionic/core';
import { ConfigContext } from '../../contexts/ConfigContext';
import moment from 'moment';

const AddStocks = ({ setStocks, setShowModel}) => {
    const [productName, setProductName] = useState('')
    const [quantity, setQuantity] = useState(0)
    const [HSN, setHSN] = useState('')
    const [Gstr, setGstr] = useState('0')
    const [purchaseRate, setPurchaseRate] = useState(0)
    const [salerate, setSaleRate] = useState(0);

    /** Add Product to Stocks */
    const addToStock = (e) => {
        e.preventDefault();

        let logentry = {
            id: `stk_${Date.now()}`,
            date: moment(Date()).format('ll'),
            type: "Opening Stock",
            quantity: parseFloat(quantity),
            rate: parseFloat(purchaseRate),
            amount: parseFloat(quantity * purchaseRate),
        }
        let data = {
            productName: productName.trim(),
            quantity: parseFloat(quantity),
            purchaseRate: parseFloat(purchaseRate),
            rate: parseFloat(salerate),
            gstRate: parseFloat(Gstr),
            hsn: HSN.trim(),
            log: [logentry],
        }

        document.getElementById('addStockForm').reset();
        document.getElementById('pname').setFocus()

        console.log(data);
        // update db
        db.stocks.put(data).then((res) => {
            console.log('Product Item added.', res);
            toastController.create({
                color: 'success',
                duration: 2000,
                message: 'Product added successfully.',
                showCloseButton: true
            }).then(toast => {
                toast.present();
                db.getStocks().then((res) => {
                    setStocks(res)
                })
                setGstr('0');
                setShowModel(false);
            });
        })
    }

    return (
        <IonCard class='ion-padding'>
            <h4 className='red-text'><strong>Add New Stock</strong></h4>
            <form onSubmit={addToStock} id='addStockForm'>
                <IonRow>
                    <IonCol size='5'>
                        <IonItem>
                            <IonLabel position='floating'>Product Name</IonLabel>
                            <IonInput type="text" required id='pname' onIonInput={(e) => setProductName((e.target.value).trim())} />
                        </IonItem>
                        <IonItem>
                            <IonLabel position='floating'>HSN/SAC Code</IonLabel>
                            <IonInput type="text" id='hsn' onIonInput={(e) => setHSN((e.target.value).trim())} />
                        </IonItem>
                        <IonItem>
                            <IonLabel position='floating'>GST Rate</IonLabel>
                            <IonSelect interface='popover' value={Gstr} id='gstr' onIonChange={(e) => setGstr(e.target.value)}>
                                <IonSelectOption value="0">Tax Free</IonSelectOption>
                                <IonSelectOption value="0.25">0.25%</IonSelectOption>
                                <IonSelectOption value="3">3%</IonSelectOption>
                                <IonSelectOption value="5">5%</IonSelectOption>
                                <IonSelectOption value="12">12%</IonSelectOption>
                                <IonSelectOption value="18">18%</IonSelectOption>
                                <IonSelectOption value="28">28%</IonSelectOption>
                            </IonSelect>
                        </IonItem>
                        <IonButton color='danger' type='submit'>
                            <IonInput type='submit' >ADD</IonInput>

                        </IonButton>

                    </IonCol>
                    <IonCol size='5'>

                        <IonItem>
                            <IonLabel position='floating'>Quantity</IonLabel>
                            <IonInput type="number" min='0' step='any' required id='quantity' onIonInput={(e) => setQuantity(parseFloat(e.target.value))} />
                        </IonItem>

                        <IonItem>
                            <IonLabel position='floating'>Purchase Price</IonLabel>
                            <IonInput type="number" min='0' step='any' id='prate' value={purchaseRate} onIonInput={(e) => setPurchaseRate(parseFloat(e.target.value))} />
                        </IonItem>

                        <IonItem>
                            <IonLabel position='floating'>Sale Price</IonLabel>
                            <IonInput type="number" min='0' step='any' id='srate' value={salerate} onIonInput={(e) => setSaleRate(parseFloat(e.target.value))} />
                        </IonItem>

                    </IonCol>
                </IonRow>
            </form>
        </IonCard>
    )
}

export default AddStocks
